import * as React from "react";
import { Interface } from "readline";
import downloadPopup from "@/assets/images/Reports/common/download-popup.svg";
import { useNavigate } from "react-router-dom";
export interface IEdModal {
  show: boolean;
  setShow: (show: boolean) => void;
  size?: string;
  title?: string;
  hideCrossBtn?: boolean;
  children?: React.ReactNode;
  icon?: string;
  showFooter: boolean;
  modalTitle: string;
  closeDropdown?: Function;
  iconimage?: boolean;
  DisableOutsideClickClose?: boolean;
  onCloseGoBack?: boolean;
  onCloseGoBackFunction?: Function;
  modalbodyClass?: string;
  iconOnClick?: Function;
  paths?: React.ReactNode;
  iconClass?: string;
  hideHeader?: boolean;
  ownCloseIcon?: string;
  titleClass?: string;
  backdropClass?: boolean;
}

const EdModal: React.FC<IEdModal> = (props: IEdModal) => {
  // const [show, setShow] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const ref = React.useRef(null);

  React.useEffect(() => {
    const body = document.querySelector("body");
    body.style.overflow = props.show ? "hidden" : "auto";
    return () => {
      body.style.overflow = "auto";
    };
  }, [props.show]);

  React.useEffect(() => {
    if (!props.DisableOutsideClickClose) {
      const handleClickOutside = (event: any) => {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          event.view.innerWidth - 17 >= event.clientX
        ) {
          props.setShow(false);
          props?.onCloseGoBackFunction && props?.onCloseGoBackFunction();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [ref]);

  return (
    <>
      <div
        className={`modal-backdrop ${props.show ? "show" : "fade"} ${
          props.backdropClass ? "additionalblur" : ""
        }`}
      ></div>
      <div
        className={`modal ${props.modalTitle} ${props.show ? "show" : "fade"}`}
      >
        <div className={`modal-dialog ${props.size}`}>
          <div className="modal-content" ref={ref}>
            {!props.hideHeader && (
              <div
                className={`modal-header align-items-center justify-content-between`}
              >
                <div
                  className={`d-flex justify-content-between align-items-center ${
                    props.iconClass && props.iconClass
                  }`}
                >
                  {props.icon && (
                    <i
                      className={props.icon}
                      onClick={() => props.iconOnClick()}
                    ></i>
                  )}
                  {props.title && (
                    <h5
                      className={`modal-title ${
                        props.titleClass ? props.titleClass : ""
                      }`}
                    >
                      {props.hasOwnProperty("title") ? props.title : ""}
                    </h5>
                  )}
                </div>
                {!props.hideCrossBtn && (
                  <button
                    type="button"
                    className={
                      props.ownCloseIcon
                        ? props.ownCloseIcon
                        : "edel-icon-bold-close"
                    }
                    onClick={() => {
                      !props.onCloseGoBack && props.setShow(false);
                      setTimeout(() => {
                        props?.closeDropdown && props?.closeDropdown(false);
                      }, 0);
                      props?.onCloseGoBack && props?.onCloseGoBackFunction();
                    }}
                  >
                    <i className=""></i>
                  </button>
                )}
              </div>
            )}
            <div className={`modal-body ${props.modalbodyClass}`}>
              {props.children}
            </div>
            {props.showFooter && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    props.setShow(false);
                    setTimeout(() => {
                      props.closeDropdown && props.closeDropdown(false);
                    }, 0);
                  }}
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default EdModal;
